import isEmpty from 'lodash/isEmpty';
import { GetServerSideProps } from 'next';
import HangOverFooter from 'src/components/sections/section-events/hang-over/footer';
import SectionFive from 'src/components/sections/section-events/hang-over/section-five';
import SectionFour from 'src/components/sections/section-events/hang-over/section-four';
import SectionOne from 'src/components/sections/section-events/hang-over/section-one';
import SectionThree from 'src/components/sections/section-events/hang-over/section-three';
import SectionTwo from 'src/components/sections/section-events/hang-over/section-two';
import { GET } from 'src/services';
import { convertDatasets } from 'src/utils/datasets';
import { convertObjPath, timestamp } from 'src/utils/helper';
import styled from 'styled-components';

function index({ sectionOne, sectionTwo, sectionThree, sectionFour, sectionFive }: any) {
  return (
    <PageWrapper>
      {convertDatasets(sectionOne?.dataSet, 'isShow', true) === 'true' ? <SectionOne /> : null}
      {convertDatasets(sectionTwo?.dataSet, 'isShow', true) === 'true' ? <SectionTwo data={sectionTwo} /> : null}
      {convertDatasets(sectionThree?.dataSet, 'isShow', true) === 'true' ? <SectionThree _data={sectionThree} /> : null}
      {convertDatasets(sectionFour?.dataSet, 'isShow', true) === 'true' ? <SectionFour data={sectionFour} /> : null}
      {convertDatasets(sectionFive?.dataSet, 'isShow', true) === 'true' && !isEmpty(sectionFive?.data) ? <SectionFive data={sectionFive} /> : null}
      <HangOverFooter />
    </PageWrapper>
  );
}
const PageWrapper = styled.div`
  width: 100%;
  position: relative;
`;
export const getServerSideProps: GetServerSideProps = async () => {
  const initProps: any = {
    statusCode: 200,
    errMessage: null,
    sectionOne: {
      dataSet: []
    },
    sectionTwo: {
      dataSet: []
    },
    sectionThree: {
      dataSet: []
    },
    sectionFour: {
      dataSet: []
    },
    sectionFive: {
      data: [],
      dataSet: []
    }
  };
  try {
    const fetchDataSet = await GET('/api/datasets');
    if (!isEmpty(fetchDataSet)) {
      const sectionOne = convertDatasets(fetchDataSet, 'section-hang-over-1', false);
      const sectionTwo = convertDatasets(fetchDataSet, 'section-hang-over-2', false);
      const sectionThree = convertDatasets(fetchDataSet, 'section-hang-over-3', false);
      const sectionFour = convertDatasets(fetchDataSet, 'section-hang-over-4', false);
      const sectionFive = convertDatasets(fetchDataSet, 'section-hang-over-5', false);
      if (!isEmpty(sectionOne)) initProps.sectionOne.dataSet = sectionOne[0];
      if (!isEmpty(sectionTwo)) initProps.sectionTwo.dataSet = sectionTwo[0];
      if (!isEmpty(sectionThree)) initProps.sectionThree.dataSet = sectionThree[0];
      if (!isEmpty(sectionFour)) initProps.sectionFour.dataSet = sectionFour[0];
      if (!isEmpty(sectionFive)) initProps.sectionFive.dataSet = sectionFive[0];
      // if (!isEmpty(convertDatasets(sectionTwo[0], 'isShow', true)) && convertDatasets(sectionTwo[0], 'isShow', true) === 'true') {
      //   const res2 = await GET(`/api/search/video/tag${convertObjPath({ name: convertDatasets(sectionTwo[0], 'tag-name', true) })}`, false, true);
      //   if (res2) {
      //     initProps.sectionTwo.data = res2?.data;
      //   }
      // }
      if (!isEmpty(convertDatasets(sectionFive[0], 'isShow', true)) && convertDatasets(sectionFive[0], 'isShow', true) === 'true') {
        const res5 = await GET(`/api/search/tag${convertObjPath({ name: convertDatasets(sectionFive[0], 'tag-name', true) })}&limit=6`, false, true);
        if (res5) {
          initProps.sectionFive.data = res5?.data;
        }
      }
    }
  } catch (err: any) {
    console.error(`${timestamp()} ==========> PAGE_INDEX ERROR : `, err.message);
    initProps.errMessage = err.message;
    initProps.statusCode = err?.response?.status || 500;
  }

  return {
    props: initProps
  };
};

export default index;
